<template>
  <div>
    <v-form ref="form" v-model="formValid">
      <div class="col-12 d-flex flex-wrap py-0">
        <div class="col-12 d-flex flex-wrap py-0">
          <div class="col-2 py-0">
            <v-select
              v-model="newContent.gender"
              v-bind="customerFieldsProperties('gender')"
            />
          </div>

          <div class="col-4 py-0">
            <v-text-field
              v-model="newContent.firstname"
              v-bind="customerFieldsProperties('firstname')"
            />
          </div>

          <div class="col-4 py-0">
            <v-text-field
              v-model="newContent.lastname"
              v-bind="customerFieldsProperties('lastname')"
            />
          </div>

          <div class="col-2 py-0">
            <DTPicker
              v-model="newContent.birth_date"
              :field="customerFieldsProperties('birth_date')"
            />
          </div>
        </div>

        <div class="col-12 d-flex flex-wrap py-0">
          <div class="col-4 py-0">
            <v-text-field
              v-model="newContent.street_number"
              v-bind="customerFieldsProperties('street_number')"
            />
          </div>
          <div class="col-8 py-0">
            <v-text-field
              v-model="newContent.street_name"
              v-bind="customerFieldsProperties('street_name')"
            />
          </div>
        </div>
        <div class="col-12 d-flex flex-wrap py-0">
          <div class="col-6 py-0">
            <v-text-field
              v-model="newContent.zip_code"
              v-bind="customerFieldsProperties('zip_code')"
            />
          </div>
          <div class="col-6 py-0">
            <v-text-field
              v-model="newContent.address2"
              v-bind="customerFieldsProperties('address2')"
            />
          </div>
        </div>
        <div class="col-12 d-flex flex-wrap py-0">
          <div class="col-6 py-0">
            <v-text-field
              v-model="newContent.town"
              v-bind="customerFieldsProperties('town')"
            />
          </div>
          <div class="col-6  py-0">
            <v-select
              v-model="newContent.country"
              v-bind="customerFieldsProperties('country')"
            />
          </div>
        </div>
        <div class="col-12 d-flex flex-wrap py-0">
          <div class="col-3  py-0">
            <v-select
              v-model="newContent.nationality"
              v-bind="customerFieldsProperties('nationality')"
            />
          </div>
          <div class="col-3 py-0">
            <v-select
              v-model="newContent.language"
              v-bind="customerFieldsProperties('language')"
            />
          </div>
          <div class="col-6 py-0">
            <NewEmailAutocomplete
              v-model="newContent.email"
              :field="customerFieldsProperties('email')"
            />
          </div>
          <div class="col-6 py-0">
            <PhoneNumberField v-model="newContent.telephone" :valid.sync="telephoneValid" :field="customerFieldsProperties('telephone')" field-name="telephone" />
          </div>
          <div class="col-6 py-0">
            <PhoneNumberField v-model="newContent.mobilephone" :valid.sync="mobilephoneValid" :field="customerFieldsProperties('mobilephone')" field-name="mobilephone" />
          </div>
        </div>
        <div class="col-12 d-flex flex-wrap py-0">
          <div class="col-12 py-0">
            <v-text-field
              v-model="newContent.membershipNumber"
              v-bind="customerFieldsProperties('membershipNumber')"
            />
          </div>
        </div>
      </div>
    </v-form>
  </div>
</template>

<script>
import { customerFieldsProperties } from '../../configs/forms';
import { utils } from '@/mixins/index';
import NewEmailAutocomplete from './NewEmailAutocomplete.vue';
import PhoneNumberField from './PhoneNumberField.vue';
import { EventBus } from '../../mixins';

import 'vue-tel-input/dist/vue-tel-input.css';

import DTPicker from './DTPicker.vue';

export default {
  name: 'ClientCardForm',
  components: {
    PhoneNumberField,
    NewEmailAutocomplete,
    DTPicker
  },
  mixins: [utils],
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    valid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // mobileValidation: {},
      oldContent: { ...this.$props.content },
      newContent: this.$props.content,
      formValid: this.$props.valid,
      telephoneValid: false,
      mobilephoneValid: false,
      date: null,
      menu: false
    };
  },
  computed: {},
  watch: {
    formValid (val) { // Updates prop via event
      this.$emit('update:valid', val);
    },
    content: function () {
      this.newContent = this.content;
    }
  },
  methods: {
    customerFieldsProperties: customerFieldsProperties,

    setAddress (place) {
      // Cleares old address
      this.newContent.street_number = null;
      this.newContent.street_name = null;
      this.newContent.address2 = null;
      this.newContent.town = null;
      this.newContent.zip_code = null;
      this.newContent.country = null;

      const componentForm = {
        street_number: { name: 'short_name', field_name: 'street_number' },
        route: { name: 'long_name', field_name: 'street_name' },
        locality: { name: 'long_name', field_name: 'town' },
        // administrative_area_level_1: { name: 'short_name', field_name: 'address2' },
        country: { name: 'short_name', field_name: 'country' },
        postal_code: { name: 'short_name', field_name: 'zip_code' }
      };

      // Get each component of the address from the place details,
      // and then fill-in the corresponding field on the form.
      for (const component of place.address_components) {
        const addressType = component.types[0];

        const componentField = componentForm[addressType];
        if (componentField) {
          const val = component[componentField.name];
          this.newContent[componentField.field_name] = val;
        }
      }
    },
    validate () {
      const validationResult = this.$refs.form.validate();

      const errors = [];


      // Must have at least one true value and both values cannot be false
      if (!(this.telephoneValid || this.mobilephoneValid) || (this.telephoneValid === false || this.mobilephoneValid === false)) {
        this.formValid = false;

        // Show expecific message if the other fields are correct
        if (validationResult) {
          errors.push('Veuillez vérifier les champs "tél" et "Mobile Tél"');
        }
      } else {
        this.formValid = validationResult;
      }

      if (!this.formValid) {

        if (this.$refs && this.$refs.form && this.$refs.form.inputs) {
          const invalidRequiredInputs = this.$refs.form.inputs.filter(i => i.hasError && i.errorBucket.filter(e => e === 'Champs Requis').length) || [];

          // Show message if required fields are not filled
          if (invalidRequiredInputs.length) {
            errors.push('Veuillez remplir toutes les informations obligatoires.');
          }
        }

        if (!errors.length) {
          errors.push('Erreur dans un des champs du formulaire');
        }
        EventBus.$emit('change-errors', errors);
      }
    },
    reset () {
      this.$refs.form.reset();
    },
    resetValidation () {
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style >
.vue-tel-input {
  border-width: 0 0 2px 0;
  border-radius: 0;
}
.vue-tel-input:focus-within {
  box-shadow: none;
  border-color:red;
}
</style>
